import type {
  FutureState,
  Initiative,
  RelatedComponentsStatus,
} from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import type { TrackingEvent } from 'tracking/trackPayload';

const isMissingPermissions = (status: RelatedComponentsStatus): boolean =>
  status === 'missing-permissions';

export const toInitiativePageLoadEvents = ({
  _id: initiativeId,
  ownersStatus,
  objectivesStatus,
  capabilityDeltasStatus,
  impactedApplicationsStatus,
}: Pick<
  Initiative,
  | '_id'
  | 'ownersStatus'
  | 'objectivesStatus'
  | 'capabilityDeltasStatus'
  | 'impactedApplicationsStatus'
>): TrackingEvent[] => {
  const payload = { initiativeId };
  const events: (TrackingEvent | false)[] = [
    { event: 'Initiatives0 Loaded initiative', payload },
    isMissingPermissions(ownersStatus) && {
      event: 'Initiatives0 Missing access to owners',
      payload,
    },
    isMissingPermissions(objectivesStatus) && {
      event: 'Initiatives0 Missing access to objectives',
      payload,
    },
    isMissingPermissions(capabilityDeltasStatus) && {
      event: 'Initiatives0 Missing access to capability deltas',
      payload,
    },
    isMissingPermissions(impactedApplicationsStatus) && {
      event: 'Initiatives0 Missing access to impacted applications',
      payload,
    },
  ];
  return events.filter(isTruthy);
};

export const toFutureStatePageLoadEvents = ({
  _id: futureStateId,
  ownersStatus,
  assignedToStatus,
}: Pick<
  FutureState,
  '_id' | 'ownersStatus' | 'assignedToStatus'
>): TrackingEvent[] => {
  const payload = { futureStateId };
  const events: (TrackingEvent | false)[] = [
    isMissingPermissions(ownersStatus) && {
      event: 'Future State0 Missing access to owners',
      payload,
    },
    isMissingPermissions(assignedToStatus) && {
      event: 'Future State0 Missing access to assignees',
      payload,
    },
  ];
  return events.filter(isTruthy);
};
